"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

define('services/dataAggregatorService',["require", "exports", "services/environmentSelectionService", "controllers/dataAggregatorController"], function (require, exports, environmentSelection, dataAggregatorController) {
    "use strict";

    var DataAggregatorService = function () {
        function DataAggregatorService() {
            _classCallCheck(this, DataAggregatorService);
        }

        _createClass(DataAggregatorService, [{
            key: "getLatestPolicyData",
            value: function getLatestPolicyData(policyId, coverEndDate) {
                var request = { environmentId: environmentSelection.selectedEnvironment().name, policyId: policyId, date: coverEndDate };
                return dataAggregatorController.getLatestPolicyData(request);
            }
        }, {
            key: "getAllLatestPolicyData",
            value: function getAllLatestPolicyData() {
                var request = { environmentId: environmentSelection.selectedEnvironment().name };
                return dataAggregatorController.getAllLatestPolicyData(request);
            }
        }, {
            key: "getNearbyPolicyholders",
            value: function getNearbyPolicyholders(environment, nwLatitude, nwLongitude, seLatitude, seLongitude) {
                var request = { environmentId: environment, nwLatitude: nwLatitude, nwLongitude: nwLongitude, seLatitude: seLatitude, seLongitude: seLongitude };
                return dataAggregatorController.getNearbyPolicyholders(request);
            }
        }, {
            key: "getPolicyholderLocationByBrokerPolicyId",
            value: function getPolicyholderLocationByBrokerPolicyId(environment, brokerPolicyId) {
                var request = { environmentId: environment, brokerPolicyId: brokerPolicyId };
                return dataAggregatorController.getPolicyholderLocationByBrokerPolicyId(request);
            }
        }, {
            key: "getPolicyholderLocationByPolicyId",
            value: function getPolicyholderLocationByPolicyId(environment, policyId) {
                var request = { environmentId: environment, policyId: policyId };
                return dataAggregatorController.getPolicyholderLocationByPolicyId(request);
            }
        }, {
            key: "getNonTransmittingPolicyholdersLocation",
            value: function getNonTransmittingPolicyholdersLocation(environment) {
                var request = { environmentId: environment };
                return dataAggregatorController.getNonTransmittingPolicyholdersLocation(request);
            }
        }, {
            key: "getUnauthorisedDeviceRemovalPolicyholdersLocation",
            value: function getUnauthorisedDeviceRemovalPolicyholdersLocation(environment) {
                var request = { environmentId: environment };
                return dataAggregatorController.getUnauthorisedDeviceRemovalPolicyholdersLocation(request);
            }
        }]);

        return DataAggregatorService;
    }();

    return new DataAggregatorService();
});
//# sourceMappingURL=dataAggregatorService.js.map;
